module.exports = __webpack_public_path__ + "static/media/stop.a5e07219.svg";